exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-b256fde4] {\n  word-break: break-word;\n  -webkit-hyphens: auto;\n      -ms-hyphens: auto;\n          hyphens: auto;\n}\n@media screen and (min-width: 1280px) {\n.width-cap[data-v-b256fde4] {\n    max-width: 240px;\n}\n}\nh4 .mb-24[data-v-b256fde4] {\n  font-size: 1.5rem;\n}\nh4 .mb-16[data-v-b256fde4] {\n  font-size: 1.5rem;\n}\n.top[data-v-b256fde4] {\n  top: 0;\n}", ""]);

// exports
